import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import { APIListWrapper } from '../../models/common/api-list-wrapper.model';
import { FleetBulkImportBatch, FleetBulkImportPreview, FleetBulkImportProcessResult, FleetBulkImportRow } from './fleet-bulk-upload.model';

@Injectable({ providedIn: 'root' })
export class FleetBulkUploadService {
  private baseUrl = `${environment.restApiUrl}fleet-bulk-import-endpoint`;

  constructor(private http: HttpClient) {}

  upload(file: File, companyId: number, transportationAgencyId: number, importType?: string): Observable<APIResponseWrapper<FleetBulkImportPreview>> {
    const form = new FormData();
    form.append('file', file);
    form.append('companyId', String(companyId));
    form.append('transportationAgencyId', String(transportationAgencyId));
    if (importType) form.append('importType', importType);
    return this.http.post<APIResponseWrapper<FleetBulkImportPreview>>(`${this.baseUrl}/batches/upload`, form);
  }

  batches(companyId: number): Observable<APIListWrapper<FleetBulkImportBatch>> {
    return this.http.get<APIListWrapper<FleetBulkImportBatch>>(`${this.baseUrl}/batches`, { params: { companyId: String(companyId) } });
  }

  batch(batchId: number): Observable<APIResponseWrapper<FleetBulkImportPreview>> {
    return this.http.get<APIResponseWrapper<FleetBulkImportPreview>>(`${this.baseUrl}/batches/${batchId}`);
  }

  updateRow(row: FleetBulkImportRow): Observable<APIResponseWrapper<FleetBulkImportRow>> {
    return this.http.put<APIResponseWrapper<FleetBulkImportRow>>(`${this.baseUrl}/rows/${row.rowId}`, { values: row.values || {} });
  }

  processBatch(batchId: number): Observable<APIResponseWrapper<FleetBulkImportProcessResult>> {
    return this.http.post<APIResponseWrapper<FleetBulkImportProcessResult>>(`${this.baseUrl}/batches/${batchId}/process`, {});
  }

  processRow(rowId: number): Observable<APIResponseWrapper<FleetBulkImportRow>> {
    return this.http.post<APIResponseWrapper<FleetBulkImportRow>>(`${this.baseUrl}/rows/${rowId}/process`, {});
  }

  template(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/template`, { observe: 'response', responseType: 'blob' });
  }
}
